import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter, map, mergeMap, first } from 'rxjs/operators';
import { CONFIGCONSTANTS } from './config/app-constants';
import { Title } from '@angular/platform-browser';
import { SettingsService } from './_services/settings-service';
import { DashboardService } from './_services/dashboard.service';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {
  appTitle: string = CONFIGCONSTANTS.siteName;
  fullTitle: string;
  constructor(private router: Router, private titleService: Title, private activatedRoute: ActivatedRoute,
    private settingsservice: SettingsService,private dash:DashboardService) {
     //  console.log = function() {} 
    //  console.error = function() {}
      this.dash.loadTheme(); 
      this.getImageData();
     }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
    this.getImageData();
    // set dynamic html title
    this.router.events
        .pipe(filter(event => event instanceof NavigationEnd),
          map(() => {
            let route = this.activatedRoute.firstChild;
            let child = route;
            while (child) {
              if (child.firstChild) {
                child = child.firstChild;
                route = child;
              } else {
                child = null;
              }
            }
            return route;
          }),
          mergeMap(route => route.data)
        )
        .subscribe(data => {          
          if (data.title) {
            this.fullTitle = this.appTitle + ' | ' + data.title;
          } else {
            this.fullTitle = this.appTitle;
          }
          this.titleService.setTitle( this.fullTitle );
        });        
  }
  getImageData() {
    this.settingsservice.getSettingsImageDataURL()
    .pipe(first())
    .subscribe(
      (data: any) => {
        let logoURL, faviconURL;
        
        //uncomment this if you want to run theme config code
        let pri,sec,ter,qua,fav,log,sit;
        pri = data.data.pri;
        sec = data.data.sec;
        ter = data.data.ter;
        qua = data.data.qua;
        fav = data.data.favicon;
        log = data.data.logo;
        sit = data.data.site_name
        //uncomment this if you want to run theme config code
        
        //comment this if you want to run theme config code
        logoURL = 'assets/img/brand/logo_updated.png';
        faviconURL = 'assets/img/brand/logo_icon.png';

        this.appTitle = data.data.site_name ? data.data.site_name : CONFIGCONSTANTS.siteName;
        if (data.data.logo) {
          logoURL = data.data.logo;
        }
        if (data.data.favicon32) {
          faviconURL = data.data.favicon32;
          this.settingsservice.changeFavicon(faviconURL);
        }

        let settings1 = [];

        const settingsItem = localStorage.getItem('settings');
        if (settingsItem) {
          try {
            settings1 = JSON.parse(settingsItem);
          } catch (e) {
          
          }
        } else {

        }

        //comment this if you want to run theme config code
        faviconURL = settings1['favicon'] ? settings1['favicon'] : faviconURL;
        this.settingsservice.changeFavicon(faviconURL);
        //comment this if you want to run theme config code

        //uncomment this if you want to run theme config code
        this.dash.setTheme(pri,sec,ter,qua,fav,logoURL,sit);
        //uncomment this if you want to run theme config code
        this.settingsservice.setSettingsData(this.appTitle, logoURL, faviconURL);
      });
    } 
}

